import { useState, useEffect } from "react";
import axios from "axios";
import { getTrackingPayload, trackLead, newEventId, getFbCookies } from "@/lib/meta";
import { hasMarketingConsent } from "@/lib/consent";
import { steps } from "./leadSteps";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const emptyForm = {
  full_name: "", brand_name: "", email: "", whatsapp: "", country: "",
  business_type: "", selling_platform: "", monthly_orders: "",
  interests: [], message: "", gdpr_consent: false,
};

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const validateStep = (i, form) => {
  if (i !== steps.length - 1) return "";
  if (!form.full_name || !form.brand_name || !form.email || !form.country) return "Compila tutti i campi obbligatori.";
  if (!EMAIL_RE.test(form.email)) return "Inserisci un indirizzo email valido.";
  if (!form.gdpr_consent) return "È necessario accettare il trattamento dei dati.";
  return "";
};

const errorMessage = (err) => {
  const d = err.response?.data?.detail;
  return typeof d === "string" ? d : "Si è verificato un errore. Riprova.";
};

// Multi-step lead form state, validation and submission (Lead pixel event only after a saved lead).
export function useLeadForm(open) {
  const [form, setForm] = useState(emptyForm);
  const [step, setStep] = useState(0);
  const [dir, setDir] = useState(1);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (open) { setDone(false); setError(""); setStep(0); }
  }, [open]);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const toggleInterest = (v) =>
    setForm((f) => ({ ...f, interests: f.interests.includes(v) ? f.interests.filter((x) => x !== v) : [...f.interests, v] }));

  const next = () => {
    const err = validateStep(step, form);
    if (err) return setError(err);
    setError(""); setDir(1); setStep((s) => s + 1);
  };
  const back = () => { setError(""); setDir(-1); setStep((s) => s - 1); };

  const submit = async (e) => {
    e.preventDefault();
    if (step < steps.length - 1) return next();
    const err = validateStep(step, form);
    if (err) return setError(err);
    setSubmitting(true);
    try {
      const event_id = newEventId();
      const { data } = await axios.post(`${API}/leads`, {
        ...form, ...getTrackingPayload(), ...getFbCookies(), event_id, marketing_consent: hasMarketingConsent(),
      });
      trackLead(data.event_id || event_id);
      setDone(true);
      setForm(emptyForm);
    } catch (err2) {
      setError(errorMessage(err2));
    } finally {
      setSubmitting(false);
    }
  };

  return { form, step, dir, submitting, error, done, set, toggleInterest, back, submit, isLast: step === steps.length - 1 };
}
